module.exports = __webpack_public_path__ + "static/media/brasoes.14fb088c.png";